(function() {
  'use strict';
  // Valores de Liquid (textos, ajustes del tema, cliente): los pinta cart-drawer-yuxus.liquid.
  var CFG = window.YX_CART_CFG || {};
  
  const cartIsSpain = window.YUXUS_CART_SPAIN || false;
  const cartIsChile = (window.YUXUS_COUNTRY_CODE === 'CL');
  const cartIsSpanish = cartIsSpain || cartIsChile;
  const currency = window.YUXUS_CART_CURRENCY || { symbol: '€', code: 'EUR' };
  const countryCode = window.YUXUS_COUNTRY_CODE || 'ES';
  const LOYALTY_API_URL = 'https://yuxus-loyalty.vercel.app/api';
  const POINTS_PER_EURO = 3;
  
  // ✅ NUEVO: IDs de productos con tag FORHERPREVENTA (cargados desde Liquid)
  const FORHER_PRODUCT_IDS = window.YUXUS_CART_FORHER_IDS || [];
  
  let loyaltyCustomerId = null;
  let loyaltyData = null;
  let loyaltyLoaded = false;
  
  let scrollPosition = 0;
  
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  
  window.YUXUS_CART = window.YUXUS_CART || {};
  window.YUXUS_CART.isReady = false;
  window.YUXUS_CART.open = function() { window.YUXUS_CART._pendingOpen = true; };
  window.YUXUS_CART.close = function() {};
  
  window.YUXUS_VARIANT_PRICES = {};
  window.YUXUS_VARIANT_PRESALE = {};
  window.YUXUS_CART_PRODUCTS = {};
  
  // ✅ NUEVO: Mapa de product ID → isForher para items añadidos dinámicamente
  // Se actualiza en refreshCart cuando leemos data-is-forher del DOM
  window.YUXUS_PRODUCT_FORHER = {};
  
  // ======================================================
  // ZONAS DE ENVÍO INTERNACIONAL
  // ======================================================
  function parseDeliveryConfig(str) {
    var map = {};
    (str || '').split('\n').forEach(function(line) {
      line = line.trim();
      if (!line || line.indexOf(':') === -1) return;
      var idx = line.indexOf(':');
      var codes = line.slice(0, idx).split(',');
      var range = line.slice(idx + 1).trim().split('-');
      var min = parseInt(range[0], 10);
      var max = (range[1] !== undefined && range[1] !== '') ? parseInt(range[1], 10) : min;
      if (isNaN(min)) return;
      if (isNaN(max)) max = min;
      codes.forEach(function(c) { c = c.trim().toUpperCase(); if (c) map[c] = { min: min, max: max }; });
    });
    return map;
  }
  var DELIVERY_MAP = parseDeliveryConfig(window.YUXUS_DELIVERY_CONFIG);
  function getInternationalZone(cc) {
    var key = (cc || '').toUpperCase();
    return DELIVERY_MAP[key] || DELIVERY_MAP['*'] || { min: 5, max: 10 };
  }
  
  // ======================================================
  // ✅ NUEVO: Función para comprobar si presale debe mostrarse como normal
  // Misma lógica que estimated-delivery.liquid:
  //   - Si el producto tiene tag FORHERPREVENTA → siempre normal (negro)
  //   - Si la fecha de inicio de presale está a menos de 4 días → normal (negro)
  // ======================================================
  function parsePresaleDatesCart(dateString) {
    if (!dateString) return null;
    try {
      var parts = dateString.split(/\s*-\s*/);
      if (parts.length !== 2) return null;
      function parseDDMMYYYY(str) {
        var p = str.trim().split('/');
        if (p.length !== 3) return null;
        var day = parseInt(p[0], 10);
        var month = parseInt(p[1], 10) - 1;
        var year = parseInt(p[2], 10);
        if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
        return new Date(year, month, day);
      }
      var startDate = parseDDMMYYYY(parts[0]);
      var endDate = parseDDMMYYYY(parts[1]);
      if (!startDate || !endDate) return null;
      return { startDate: startDate, endDate: endDate };
    } catch (e) { return null; }
  }
  
  function shouldShowPresaleAsNormalCart(productId, dateString) {
    // Comprobar FORHERPREVENTA por product ID
    var pid = parseInt(productId);
    if (FORHER_PRODUCT_IDS.includes(pid)) {
      return true;
    }
    // También revisar el mapa dinámico (para items añadidos vía cross-sell/refresh)
    if (window.YUXUS_PRODUCT_FORHER[pid]) {
      return true;
    }
    
    // Comprobar si la presale está a menos de 4 días
    var parsed = parsePresaleDatesCart(dateString);
    if (!parsed) return false;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var startDate = new Date(parsed.startDate);
    startDate.setHours(0, 0, 0, 0);
    var diffMs = startDate.getTime() - today.getTime();
    var diffDays = diffMs / (1000 * 60 * 60 * 24);
    return diffDays < 4;
  }
  
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents) || 0;
    // CLP (Chile) no usa decimales y usa el punto como separador de miles → "$165.030".
    if (countryCode === 'CL' || currency.code === 'CLP') {
      var pesos = Math.round(cents / 100);
      var formatted;
      try {
        formatted = pesos.toLocaleString('es-CL');
      } catch (e) {
        formatted = String(pesos);
      }
      return currency.symbol + formatted;
    }
    const amount = (cents / 100).toFixed(2);
    if (currency.symbol === '£' || currency.symbol === '$') {
      return currency.symbol + amount;
    } else {
      return amount.replace('.', ',') + currency.symbol;
    }
  }
  
  function formatDateNumeric(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    if (cartIsSpanish) {
      return day + '/' + month + '/' + year;
    } else {
      return month + '/' + day + '/' + year;
    }
  }
  
  async function checkLoyaltyStatus() {
    hideLoyaltyBar();
    
    if (window.__yuxusCustomer && window.__yuxusCustomer.id) {
      loyaltyCustomerId = String(window.__yuxusCustomer.id);
      await fetchLoyaltyData();
      return;
    }
    
    if (CFG.customerId) {
      loyaltyCustomerId = String(CFG.customerId);
      await fetchLoyaltyData();
      return;
    }
    
    try {
      const response = await fetch('/account.json');
      if (response.ok) {
        const data = await response.json();
        if (data.customer && data.customer.id) {
          loyaltyCustomerId = String(data.customer.id);
          await fetchLoyaltyData();
          return;
        }
      }
    } catch (e) {}
    
    loyaltyLoaded = true;
    loyaltyData = null;
  }
  
  async function fetchLoyaltyData() {
    if (!loyaltyCustomerId) { loyaltyLoaded = true; loyaltyData = null; return; }
    try {
      const res = await fetch(LOYALTY_API_URL + '/proxy', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'get_customer', data: { customer_id: loyaltyCustomerId } })
      });
      const json = await res.json();
      if (json.success && json.data && json.data.loyalty && json.data.loyalty.isActivated) {
        loyaltyData = json.data.loyalty;
        loyaltyLoaded = true;
        updateLoyaltyDisplay();
      } else { loyaltyData = null; loyaltyLoaded = true; }
    } catch (err) {
      console.error('Cart Drawer: Error fetching loyalty data:', err);
      loyaltyData = null; loyaltyLoaded = true;
    }
  }
  
  const DIRECT_CURRENCIES = ['EUR', 'GBP', 'USD'];
  const CURRENCY_TO_EUR = {
    'CHF': 1.07, 'SEK': 0.091, 'NOK': 0.088, 'DKK': 0.134, 'PLN': 0.23,
    'CZK': 0.040, 'HUF': 0.0025, 'RON': 0.20, 'BGN': 0.51, 'ISK': 0.007,
    'RSD': 0.0085, 'JPY': 0.0058, 'CNY': 0.13, 'HKD': 0.11, 'SGD': 0.70,
    'KRW': 0.00069, 'INR': 0.011, 'THB': 0.028, 'MYR': 0.21, 'PHP': 0.017,
    'IDR': 0.000060, 'VND': 0.000039, 'TWD': 0.030, 'CAD': 0.69, 'MXN': 0.052,
    'BRL': 0.18, 'ARS': 0.0009, 'CLP': 0.0010, 'COP': 0.00024, 'PEN': 0.26,
    'AUD': 0.61, 'NZD': 0.56, 'AED': 0.23, 'SAR': 0.23, 'ILS': 0.26,
    'ZAR': 0.052, 'TRY': 0.029, 'RUB': 0.0095
  };
  
  function calculatePointsToEarn(cartTotalCents) {
    const currencyCode = window.YUXUS_CART_CURRENCY?.code || 'EUR';
    let amountInUnits = cartTotalCents / 100;
    if (DIRECT_CURRENCIES.includes(currencyCode)) return Math.floor(amountInUnits * POINTS_PER_EURO);
    const conversionRate = CURRENCY_TO_EUR[currencyCode];
    if (conversionRate) return Math.floor(amountInUnits * conversionRate * POINTS_PER_EURO);
    return Math.floor(amountInUnits * POINTS_PER_EURO);
  }
  
  function updateLoyaltyDisplay(cartTotalCents) {
    if (!loyaltyData || !loyaltyLoaded) { hideLoyaltyBar(); return; }
    if (typeof cartTotalCents === 'undefined') {
      fetch('/cart.js').then(r => r.json()).then(cart => { updateLoyaltyDisplayWithTotal(cart.total_price); }).catch(() => { updateLoyaltyDisplayWithTotal(0); });
    } else { updateLoyaltyDisplayWithTotal(cartTotalCents); }
  }
  
  function updateLoyaltyDisplayWithTotal(cartTotalCents) {
    const loyaltyFooterRow = document.getElementById('loyalty-footer-row');
    if (!loyaltyData) { if (loyaltyFooterRow) loyaltyFooterRow.style.display = 'none'; return; }
    const currentPoints = loyaltyData.pointsBalance || 0;
    const pointsToEarn = calculatePointsToEarn(cartTotalCents);
    if (loyaltyFooterRow) {
      const balanceEl = document.getElementById('loyalty-footer-balance');
      const earningEl = document.getElementById('loyalty-footer-earning');
      if (balanceEl) balanceEl.textContent = currentPoints.toLocaleString();
      if (earningEl) earningEl.textContent = '+' + pointsToEarn + ' pts';
      loyaltyFooterRow.style.display = 'flex';
    }
  }
  
  function hideLoyaltyBar() {
    const loyaltyFooterRow = document.getElementById('loyalty-footer-row');
    if (loyaltyFooterRow) loyaltyFooterRow.style.display = 'none';
  }
  
  // Metadatos compartidos durante esta página: abrir, cambiar cantidad y añadir
  // upsells no necesitan descargar otra vez cada producto del carrito.
  const productDataRequests = new Map();
  async function fetchProductData(handle) {
    if (!handle) return;
    if (window.YUXUS_CART_PRODUCTS[handle]) return window.YUXUS_CART_PRODUCTS[handle];
    if (productDataRequests.has(handle)) return productDataRequests.get(handle);
    const request = (async function() {
      try {
        const response = await fetch('/products/' + handle + '.js');
        if (!response.ok) return;
        const product = await response.json();
        if (!product || !Array.isArray(product.variants)) return;
        window.YUXUS_CART_PRODUCTS[handle] = product;
        product.variants.forEach(variant => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) window.YUXUS_VARIANT_PRICES[variant.id] = variant.compare_at_price;
        });
        return product;
      } catch (error) {}
    })();
    productDataRequests.set(handle, request);
    return request.finally(function() { productDataRequests.delete(handle); });
  }
  
  function getCrossSellProducts(cartProductIds) {
    const fallback = window.YUXUS_FALLBACK_PRODUCTS || [];
    return fallback.filter(p => !cartProductIds.includes(p.id) && p.image && p.image !== '');
  }
  
  async function updateCartAttributesForCrosssell(productTitle, variantTitle, price) {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      let crosssellProducts = [];
      if (cart.attributes && cart.attributes.crosssell_products) {
        try { crosssellProducts = cart.attributes.crosssell_products.split(', ').filter(s => s.trim()); } catch(e) { crosssellProducts = []; }
      }
      const productEntry = productTitle + (variantTitle && variantTitle !== 'ONE SIZE' ? ' - ' + variantTitle : '');
      if (!crosssellProducts.includes(productEntry)) crosssellProducts.push(productEntry);
      let crosssellRevenue = parseFloat(cart.attributes?.crosssell_revenue || 0);
      crosssellRevenue += (price / 100);
      await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'has_crosssell': 'true', 'crosssell_count': crosssellProducts.length.toString(), 'crosssell_products': crosssellProducts.join(', '), 'crosssell_last_added': productEntry, 'crosssell_revenue': crosssellRevenue.toFixed(2), 'crosssell_timestamp': new Date().toISOString() } })
      });
    } catch (error) {}
  }
  
  function trackCrosssellAdd(productTitle, variantTitle, price, productId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'crosssell_add_to_cart', 'crosssell_product': productTitle, 'crosssell_variant': variantTitle || '', 'crosssell_price': price / 100, 'crosssell_product_id': productId, 'crosssell_timestamp': new Date().toISOString() });
    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', { 'event_category': 'Cross-sell', 'event_label': productTitle, 'value': price / 100, 'currency': currency.code, 'items': [{ 'item_id': productId, 'item_name': productTitle, 'item_variant': variantTitle || '', 'price': price / 100, 'quantity': 1 }] });
    }
  }
  
  function createPopupElements() {
    const existingOverlay = document.getElementById('yuxus-size-popup-overlay');
    const existingPopup = document.getElementById('yuxus-size-popup');
    if (existingOverlay) existingOverlay.remove();
    if (existingPopup) existingPopup.remove();
    const overlay = document.createElement('div');
    overlay.id = 'yuxus-size-popup-overlay'; overlay.className = 'yuxus-size-popup-overlay';
    overlay.addEventListener('click', closeSizePopup);
    document.body.appendChild(overlay);
    const popup = document.createElement('div');
    popup.id = 'yuxus-size-popup'; popup.className = 'yuxus-size-popup';
    document.body.appendChild(popup);
  }
  
  function showSizePopup(product) {
    let overlay = document.getElementById('yuxus-size-popup-overlay');
    let popup = document.getElementById('yuxus-size-popup');
    if (!overlay || !popup) { createPopupElements(); overlay = document.getElementById('yuxus-size-popup-overlay'); popup = document.getElementById('yuxus-size-popup'); }
    let sizesHTML = '';
    product.variants.forEach(variant => {
      const disabled = !variant.available ? 'disabled' : '';
      sizesHTML += '<button type="button" class="yuxus-size-btn" data-variant-id="' + variant.id + '" data-variant-title="' + variant.title + '" data-variant-price="' + variant.price + '" data-product-url="' + product.url + '" data-product-handle="' + product.handle + '" data-product-title="' + product.title + '" data-product-id="' + product.id + '" data-compare-price="' + (variant.compare_at_price || '') + '" data-is-presale="' + (variant.isPresale || false) + '" data-presale-dates="' + (variant.presaleDates || '') + '" ' + disabled + '>' + variant.title + '</button>';
    });
    const popupTitle = product.title;
    popup.innerHTML = '<button type="button" class="yuxus-popup-close">×</button><h3 class="yuxus-popup-title">' + popupTitle + '</h3><div class="yuxus-popup-options">' + sizesHTML + '</div>';
    popup.querySelector('.yuxus-popup-close').addEventListener('click', closeSizePopup);
    popup.querySelectorAll('.yuxus-size-btn:not([disabled])').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeSizePopup();
        addCrossSellItem(this.dataset.variantId, this.dataset.productUrl, this.dataset.comparePrice, this.dataset.productHandle, this.dataset.isPresale === 'true', this.dataset.presaleDates, this.dataset.productTitle, this.dataset.variantTitle, parseInt(this.dataset.variantPrice), this.dataset.productId);
      });
    });
    popup.classList.add('active');
    overlay.classList.add('active');
  }
  
  function closeSizePopup() {
    const popup = document.getElementById('yuxus-size-popup');
    const overlay = document.getElementById('yuxus-size-popup-overlay');
    if (popup) popup.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
  }
  window.closeSizePopup = closeSizePopup;
  
  async function addCrossSellItem(variantId, productUrl, comparePrice, productHandle, isPresale, presaleDates, productTitle, variantTitle, variantPrice, productId) {
    if (comparePrice && comparePrice !== 'null' && comparePrice !== '') window.YUXUS_VARIANT_PRICES[variantId] = parseFloat(comparePrice);
    if (isPresale && presaleDates) window.YUXUS_VARIANT_PRESALE[variantId] = { isPresale: true, dates: presaleDates };
    if (productHandle) fetchProductData(productHandle);
    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_source': 'cart_crosssell', '_added_at': new Date().toISOString(), '_product': productTitle } }] })
      });
      if (!addResponse.ok) throw new Error('Error adding to cart');
      if (window.yuxusResetCartTimer) window.yuxusResetCartTimer();
      await updateCartAttributesForCrosssell(productTitle, variantTitle, variantPrice);
      trackCrosssellAdd(productTitle, variantTitle, variantPrice, productId);
      const drawer = document.getElementById('cart-drawer-yuxus');
      const header = drawer ? drawer.querySelector('.cart-drawer-yuxus__header') : null;
      if (header) { header.style.transition = 'background 0.3s ease'; header.style.background = '#10b981'; setTimeout(() => { header.style.background = ''; }, 500); }
      setTimeout(() => { refreshCart(); }, 200);
    } catch (error) { window.location.href = productUrl; }
  }
  window.addCrossSellItem = addCrossSellItem;
  
  function updateSubtotalWithDiscount(cart) {
    const subtotalEl = document.getElementById('cart-subtotal');
    const subtotalOriginalEl = document.getElementById('cart-subtotal-original');
    const subtotalSavingsEl = document.getElementById('cart-subtotal-savings');
    if (!subtotalEl) return;
    let totalOriginalCents = 0; let hasDiscount = false;
    cart.items.forEach(item => {
      const comparePrice = window.YUXUS_VARIANT_PRICES[item.variant_id];
      if (comparePrice && comparePrice > item.price) { hasDiscount = true; totalOriginalCents += comparePrice * item.quantity; } else { totalOriginalCents += item.final_line_price; }
    });
    subtotalEl.textContent = formatMoney(cart.total_price);
    if (hasDiscount && subtotalOriginalEl && subtotalSavingsEl) {
      subtotalOriginalEl.textContent = formatMoney(totalOriginalCents); subtotalOriginalEl.style.display = 'block';
      subtotalSavingsEl.textContent = (CFG.t_yuxus_cart_save) + ' ' + formatMoney(totalOriginalCents - cart.total_price); subtotalSavingsEl.style.display = 'block';
      subtotalEl.classList.add('has-discount');
    } else if (subtotalOriginalEl && subtotalSavingsEl) { subtotalOriginalEl.style.display = 'none'; subtotalSavingsEl.style.display = 'none'; subtotalEl.classList.remove('has-discount'); }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const drawer = document.getElementById('cart-drawer-yuxus');
    const backdrop = document.getElementById('cart-drawer-backdrop');
    if (!drawer || !backdrop) return;
    
    createPopupElements();
    checkLoyaltyStatus();
    
    const initialHandles = new Set();
    document.querySelectorAll('.cart-drawer-yuxus__item[data-variant-id]').forEach(item => {
      const variantId = item.dataset.variantId;
      const comparePrice = item.dataset.comparePrice;
      const productHandle = item.dataset.productHandle;
      const productId = item.dataset.productId;
      if (productHandle) initialHandles.add(productHandle);
      if (variantId && item.dataset.isPresale === 'true' && item.dataset.presaleDates) window.YUXUS_VARIANT_PRESALE[variantId] = { isPresale: true, dates: item.dataset.presaleDates };
      if (variantId && comparePrice && comparePrice !== 'null' && comparePrice !== '') window.YUXUS_VARIANT_PRICES[variantId] = parseFloat(comparePrice);
      // ✅ NUEVO: Registrar isForher desde data attribute
      if (productId && item.dataset.isForher === 'true') window.YUXUS_PRODUCT_FORHER[parseInt(productId)] = true;
    });
    initialHandles.forEach(handle => fetchProductData(handle));
    
    const closeBtn = drawer.querySelector('.cart-drawer-yuxus__close');
    
    function closeDrawer() {
      closeCartSizeGuide();
      closeBracketPanel();
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-active');
      setTimeout(() => {
        if (isIOS) {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
        }
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.documentElement.style.overflow = '';
        window.scrollTo(0, scrollPosition);
      }, 300);
    }
    
    function openDrawer() {
      if (document.body.style.overflow !== 'hidden') {
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      }
      drawer.classList.add('is-open');
      backdrop.classList.add('is-active');
      
      if (isIOS) {
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scrollPosition + 'px';
        document.body.style.width = '100%';
      }
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      
      refreshCart();
    }
    
    window.YUXUS_CART.open = openDrawer;
    window.YUXUS_CART.close = closeDrawer;
    window.YUXUS_CART.isReady = true;
    window.SLIDECART_OPEN = openDrawer;
    window.updateCartDrawer = function() { refreshCart(); openDrawer(); };
    
    if (window.YUXUS_CART._pendingOpen) { delete window.YUXUS_CART._pendingOpen; openDrawer(); }

    // CRO 2.1: /cart redirige aquí con ?cart=open (sections/cart-open-drawer.liquid). Abre el drawer y limpia la URL.
    try {
      var cartUrl = new URL(window.location.href);
      if (cartUrl.searchParams.get('cart') === 'open') {
        cartUrl.searchParams.delete('cart');
        history.replaceState(history.state, '', cartUrl.pathname + cartUrl.search + cartUrl.hash);
        openDrawer();
      }
    } catch (e) {}
    
    function getShippingThresholdInfo() {
      // Single source: server-computed threshold from Theme settings → "Free shipping thresholds"
      var cents = (typeof window.YUXUS_FREE_SHIP_CENTS === 'number' && window.YUXUS_FREE_SHIP_CENTS > 0) ? window.YUXUS_FREE_SHIP_CENTS : 12000;
      return { threshold: cents / 100, thresholdCents: cents };
    }
    
    async function updateFreeShippingBar() {
      const wrapper = document.getElementById('shipping-wrapper');
      if (!wrapper) return;
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const cartTotalCents = cart.total_price;
        const { thresholdCents } = getShippingThresholdInfo();
        const amountLeftCents = thresholdCents - cartTotalCents;
        const progress = Math.min(100, Math.max(0, (cartTotalCents / thresholdCents) * 100));
        if (cart.item_count === 0) { wrapper.innerHTML = ''; wrapper.style.display = 'none'; return; }
        wrapper.style.display = 'block';
        var fillColor = window.YUXUS_SHIP_FILL_COLOR || '#000000';
        var amountColor = window.YUXUS_SHIP_AMOUNT_COLOR || '#ff0000';
        // La nota de excepciones: este innerHTML borra la que pinto el
        // servidor, asi que se vuelve a meter. Vacio en los paises que no la
        // necesitan. El <script> del snippet ya corrio arriba; esto es solo
        // el boton, que innerHTML si sabe montar.
        var fsxHtml = CFG.fsxButton;
        if (amountLeftCents <= 0) {
          var doneText = window.YUXUS_SHIP_DONE_TEXT || CFG.t_yuxus_cart_free_shipping_applied;
          wrapper.innerHTML = '<div class="cart-drawer-yuxus__shipping"><p class="cart-drawer-yuxus__shipping-text"><strong>' + doneText + '</strong>' + fsxHtml + '</p><div class="cart-drawer-yuxus__progress-bar"><div class="cart-drawer-yuxus__progress-fill" style="width: 100%; background: ' + fillColor + ' !important;"></div></div></div>';
        } else {
          var amountHtml = '<strong style="color: ' + amountColor + ';">' + formatMoney(amountLeftCents) + '</strong>';
          var progressTpl = window.YUXUS_SHIP_PROGRESS_TEXT || CFG.t_yuxus_cart_free_shipping_progress;
          var progressText = progressTpl.indexOf('{amount}') !== -1 ? progressTpl.replace('{amount}', amountHtml) : (progressTpl + ' ' + amountHtml);
          wrapper.innerHTML = '<div class="cart-drawer-yuxus__shipping"><p class="cart-drawer-yuxus__shipping-text">' + progressText + fsxHtml + '</p><div class="cart-drawer-yuxus__progress-bar"><div class="cart-drawer-yuxus__progress-fill" style="width: ' + progress.toFixed(1) + '%; background: ' + fillColor + ' !important;"></div></div></div>';
        }
      } catch (error) {}
    }
    
    function isSpanishHoliday(date) {
      const month = date.getMonth(); const day = date.getDate();
      const holidays = [{month:0,day:1},{month:0,day:6},{month:4,day:1},{month:7,day:15},{month:9,day:12},{month:10,day:1},{month:11,day:6},{month:11,day:8},{month:11,day:25}];
      return holidays.some(h => h.month === month && h.day === day);
    }
    
    function getNextBusinessDay(date, skipFirst) {
      let r = new Date(date);
      if (skipFirst) r.setDate(r.getDate() + 1);
      while (r.getDay() === 0 || r.getDay() === 6 || isSpanishHoliday(r)) r.setDate(r.getDate() + 1);
      return r;
    }
    
    function addBusinessDays(startDate, daysToAdd) {
      let r = new Date(startDate); let added = 0;
      while (added < daysToAdd) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6 && !isSpanishHoliday(r)) added++; }
      return r;
    }
    
    function calculateDeliveryDates() {
      const orderDate = new Date();
      const isAfterCutoff = (orderDate.getHours() > 0) || (orderDate.getHours() === 0 && orderDate.getMinutes() >= 0);
      let minD, maxD;
      if (isAfterCutoff) { const s = getNextBusinessDay(orderDate, true); minD = new Date(s); maxD = addBusinessDays(s, 2); }
      else { const s = getNextBusinessDay(orderDate, false); minD = addBusinessDays(s, 1); maxD = addBusinessDays(s, 2); }
      return { minDeliveryDate: minD, maxDeliveryDate: maxD };
    }
    
    function calculateInternationalDeliveryDates(minDays, maxDays) {
      const orderDate = new Date();
      const isAfterCutoff = (orderDate.getHours() > 0) || (orderDate.getHours() === 0 && orderDate.getMinutes() >= 0);
      const shippingDate = isAfterCutoff
        ? getNextBusinessDay(orderDate, true)
        : getNextBusinessDay(orderDate, false);
      const minD = addBusinessDays(shippingDate, minDays - 1);
      const maxD = addBusinessDays(shippingDate, maxDays - 1);
      return { minDeliveryDate: minD, maxDeliveryDate: maxD };
    }
    
    // ======================================================
    // ✅ MODIFICADO: updateCartDeliveryTimer
    // Ahora aplica la misma lógica que estimated-delivery.liquid:
    //   1) Busca si hay algún item presale en el carrito
    //   2) Si lo hay, comprueba shouldShowPresaleAsNormalCart()
    //      - FORHERPREVENTA → estilo negro, label "Se envía entre:"
    //      - <4 días → estilo negro, label "Se envía entre:"
    //      - ≥4 días → estilo naranja, label "Se envía entre:"
    //   3) Si no hay presale → entrega normal
    // ======================================================
    function updateCartDeliveryTimer() {
      const deliveryEl = document.getElementById('cart-delivery-timer');
      const deliveryLabel = document.getElementById('delivery-label');
      const deliveryWrapper = document.getElementById('delivery-row');
      if (!deliveryEl) return;
      
      // Buscar items presale en el DOM
      let hasPresale = false;
      let presaleDates = '';
      let presaleProductId = '';
      
      document.querySelectorAll('.cart-drawer-yuxus__item').forEach(item => {
        if (item.dataset.isPresale === 'true' && item.dataset.presaleDates && item.dataset.presaleDates.trim() !== '') {
          hasPresale = true;
          presaleDates = item.dataset.presaleDates;
          presaleProductId = item.dataset.productId || '';
        }
      });
      // Fallback: revisar YUXUS_VARIANT_PRESALE
      if (!hasPresale) {
        document.querySelectorAll('.cart-drawer-yuxus__item').forEach(item => {
          const pd = window.YUXUS_VARIANT_PRESALE[item.dataset.variantId];
          if (pd && pd.isPresale && pd.dates) {
            hasPresale = true;
            presaleDates = pd.dates;
            presaleProductId = item.dataset.productId || '';
          }
        });
      }
      
      if (hasPresale && presaleDates) {
        if (deliveryWrapper) deliveryWrapper.style.display = '';
        
        // ✅ NUEVO: Comprobar si debe mostrarse como normal (FORHERPREVENTA o <4 días)
        var showAsNormal = shouldShowPresaleAsNormalCart(presaleProductId, presaleDates);
        
        // Label siempre es "Se envía entre:" / "Ships between:" para presale
        var presaleLabel = CFG.t_yuxus_cart_ships_between;
        
        if (showAsNormal) {
          // ✅ Estilo NEGRO (como entrega normal) pero con label de presale
          console.log('📦 Cart: Presale como NORMAL (FORHERPREVENTA o <4 días)');
          deliveryEl.textContent = presaleDates;
          deliveryEl.style.color = '#000';
          deliveryEl.style.fontWeight = '500';
          if (deliveryLabel) {
            deliveryLabel.textContent = presaleLabel;
            deliveryLabel.style.color = '';
          }
          if (deliveryWrapper) deliveryWrapper.classList.remove('has-presale');
        } else {
          // ✅ Estilo NARANJA (presale lejana, 4+ días)
          console.log('📦 Cart: Presale LEJANA (4+ días) - Estilo naranja');
          deliveryEl.textContent = presaleDates;
          deliveryEl.style.color = '#FF6B00';
          deliveryEl.style.fontWeight = '600';
          if (deliveryLabel) {
            deliveryLabel.textContent = presaleLabel;
            deliveryLabel.style.color = '#FF6B00';
          }
          if (deliveryWrapper) deliveryWrapper.classList.add('has-presale');
        }
        return;
      }
      
      // ✅ Sin presale: entrega normal
      if (deliveryWrapper) deliveryWrapper.style.display = '';
      deliveryEl.style.color = '#000'; deliveryEl.style.fontWeight = '500';
      if (deliveryLabel) { deliveryLabel.textContent = CFG.t_yuxus_cart_estimated_delivery; deliveryLabel.style.color = ''; }
      if (deliveryWrapper) deliveryWrapper.classList.remove('has-presale');
      
      let dates;
      const zone = getInternationalZone(countryCode);
      dates = calculateInternationalDeliveryDates(zone.min, zone.max);
      deliveryEl.textContent = formatDateNumeric(dates.minDeliveryDate) + ' - ' + formatDateNumeric(dates.maxDeliveryDate);
    }
    
    // ============ AVISO DE TALLA (ANTI-BRACKETING) ============
    // Theme settings → Cart drawer → interruptor general.
    var BRACKETING_ON = CFG.bracketingOn;
    // `| t` devuelve el texto ya escapado (' → &#39;): se decodifica aquí y se
    // escapa al pintarlo, para que no salga el código en pantalla.
    function bpDecode(s) { var t = document.createElement('textarea'); t.innerHTML = s == null ? '' : String(s); return t.value; }

    // Abre la MISMA guía de tallas de la PDP (vista ?view=size-guide) como
    // sub-pantalla del carrito (#cart-sg-view). Se renombran ids y globales para
    // no chocar con el modal de la PDP si estamos en una ficha, el modal se monta
    // en #cart-sg-host en vez de en <body>, y se quita su bloqueo de scroll (el
    // drawer ya bloquea el body; si no, pisa su `top` en iOS).
    var cartSgCache = {};
    var SG_LOADING = bpDecode(CFG.t_yuxus_pdp_sg_loading);
    function closeCartSizeGuide() {
      var v = document.getElementById('cart-sg-view');
      if (v) v.hidden = true;
      var m = document.getElementById('sizeGuideModalCart');
      if (m) m.remove();
    }
    async function openCartSizeGuide(handle, trigger) {
      if (trigger) trigger.classList.add('is-loading');
      var view = document.getElementById('cart-sg-view');
      var host = document.getElementById('cart-sg-host');
      if (view && host) {
        var oldM = document.getElementById('sizeGuideModalCart');
        if (oldM) oldM.remove();
        host.innerHTML = '<div class="cart-drawer-yuxus__sgv-loading">' + bpEsc(SG_LOADING) + '</div>';
        host.scrollTop = 0;
        view.hidden = false;
      }
      try {
        var html = cartSgCache[handle];
        if (!html) {
          var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          var r = await fetch(base + 'products/' + encodeURIComponent(handle) + '?view=size-guide');
          if (!r.ok) throw new Error(r.status);
          html = (await r.text())
            .replace(/\b(sizeGuideBtn|sizeGuideModal|sgLoading|sgResult|sgImage|sgTableWrap|sgError|sgTabs)\b/g, '$1Cart')
            .replace(/window\.YUXUS_/g, 'window.YUXUS_CSG_')
            .replace(/if \(modal\.parentNode !== document\.body\) \{\s*document\.body\.appendChild\(modal\);\s*\}/, "(document.getElementById('cart-sg-host') || document.body).appendChild(modal);")
            .replace("document.body.classList.add('size-guide-open');", '')
            .replace("document.body.style.top = '-' + window.scrollY + 'px';", '')
            .replace("document.body.style.top = '';", '')
            .replace("window.scrollTo(0, parseInt(sy || '0') * -1);", '');
          cartSgCache[handle] = html;
        }
        var oldModal = document.getElementById('sizeGuideModalCart');
        if (oldModal) oldModal.remove();
        var holder = document.getElementById('cart-sg-holder');
        if (!holder) {
          holder = document.createElement('div');
          holder.id = 'cart-sg-holder';
          holder.style.display = 'none';
          document.body.appendChild(holder);
        }
        holder.innerHTML = html;
        holder.querySelectorAll('script').forEach(function (old) {
          var s = document.createElement('script');
          s.textContent = old.textContent;
          old.parentNode.replaceChild(s, old);
        });
        if (host) host.innerHTML = '';
        var sgBtn = document.getElementById('sizeGuideBtnCart');
        // Clic que NO burbujea: con .click() llegaba al document y el cierre por
        // "clic fuera" cerraba el carrito (el botón vive fuera del drawer).
        if (sgBtn) sgBtn.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
      } catch (e) {
        closeCartSizeGuide();
      } finally {
        if (trigger) trigger.classList.remove('is-loading');
      }
    }

    // ---- Pantalla "¿Dudas con la talla?" ----
    // Sale hasta que elige una opción, por combinación producto+tallas
    // (localStorage, persiste entre pestañas y visitas): si luego añade una tercera talla vuelve a salir.
    var BP_ON = BRACKETING_ON;
    var BP_T = {
      title: CFG.bpTitle,
      subtitle: CFG.t_yuxus_cart_bracketing_panel_subtitle,
      text: CFG.bpText,
      keepSize: CFG.t_yuxus_cart_bracketing_keep_size,
      keepBoth: CFG.t_yuxus_cart_bracketing_keep_both,
      keepAll: CFG.t_yuxus_cart_bracketing_keep_all
    };
    var BP_KEY = 'yuxus_bracket_ack';
    Object.keys(BP_T).forEach(function (k) { BP_T[k] = bpDecode(BP_T[k]); });
    var bpGroup = null;
    function bpAcked() { try { return JSON.parse(localStorage.getItem(BP_KEY) || '[]'); } catch (e) { return []; } }
    function bpAck(sig) {
      try { var a = bpAcked(); if (a.indexOf(sig) === -1) { a.push(sig); localStorage.setItem(BP_KEY, JSON.stringify(a.slice(-50))); } } catch (e) {}
    }
    function bpEsc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

    // groups: [{ productId, handle, title, image, sig, sizes: [{ variantId, label }] }]
    // sizes viene en el orden de /cart.js (lo último añadido primero).
    function maybeOpenBracketPanel(groups) {
      if (!BP_ON || !drawer.classList.contains('is-open') || drawer.classList.contains('is-wishlist-view')) return;
      var acked = bpAcked();
      for (var i = 0; i < groups.length; i++) {
        if (acked.indexOf(groups[i].sig) === -1) { openBracketPanel(groups[i]); return; }
      }
    }

    function openBracketPanel(g) {
      var panel = document.getElementById('cart-bracket-panel');
      if (!panel) return;
      bpGroup = g;
      panel.querySelector('.cart-drawer-yuxus__bp-title').textContent = BP_T.title;
      panel.querySelector('.cart-drawer-yuxus__bp-subtitle').textContent = BP_T.subtitle;
      panel.querySelector('.cart-drawer-yuxus__bp-text').textContent = BP_T.text;
      var img = panel.querySelector('.cart-drawer-yuxus__bp-image img');
      img.src = g.image || ''; img.alt = g.title;
      img.parentNode.style.display = g.image ? '' : 'none';
      panel.querySelector('.cart-drawer-yuxus__bp-name').textContent = g.title;
      panel.querySelector('.cart-drawer-yuxus__bp-sizes').innerHTML = g.sizes.map(function (s) {
        return '<span class="cart-drawer-yuxus__bp-size">' + bpEsc(s.label) + '</span>';
      }).join('');
      panel.querySelector('.cart-drawer-yuxus__bp-guide').dataset.sgHandle = g.handle;
      // Una opción por talla (la recién añadida en negro) + mantener todas.
      var html = g.sizes.map(function (s, i) {
        return '<button type="button" class="cart-drawer-yuxus__bp-btn' + (i === 0 ? ' cart-drawer-yuxus__bp-btn--primary' : '') + '" data-bp-keep="' + s.variantId + '">' + bpEsc(BP_T.keepSize.replace('{size}', s.label)) + '</button>';
      }).join('');
      html += '<button type="button" class="cart-drawer-yuxus__bp-btn cart-drawer-yuxus__bp-btn--link" data-bp-keep="all">' + bpEsc(g.sizes.length > 2 ? BP_T.keepAll : BP_T.keepBoth) + '</button>';
      panel.querySelector('.cart-drawer-yuxus__bp-actions').innerHTML = html;
      panel.classList.remove('is-busy');
      panel.hidden = false;
      panel.querySelector('.cart-drawer-yuxus__bp-body').scrollTop = 0;
    }

    // Al cambiar de pestaña (medidas / conversión) se sube la tabla a la vista:
    // en móvil las pestañas quedan al pie y el cambio pasaba desapercibido.
    (function () {
      var host = document.getElementById('cart-sg-host');
      if (!host) return;
      host.addEventListener('click', function (e) {
        var tab = e.target.closest('.sg-tab');
        if (!tab) return;
        var tabs = tab.closest('.sg-tabs');
        setTimeout(function () {
          host.scrollTo({ top: Math.max(0, tabs.getBoundingClientRect().top - host.getBoundingClientRect().top + host.scrollTop - 8), behavior: 'smooth' });
        }, 0);
      }, true);
    })();

    document.addEventListener('keydown', function (e) {
      var v = document.getElementById('cart-sg-view');
      if (e.key === 'Escape' && v && !v.hidden) closeCartSizeGuide();
    });

    function closeBracketPanel() {
      var panel = document.getElementById('cart-bracket-panel');
      if (panel) panel.hidden = true;
      bpGroup = null;
    }

    async function bracketKeep(choice) {
      var g = bpGroup;
      // Solo se da por vista cuando elige algo; si cierra el carrito sin decidir, vuelve a salir.
      if (g) bpAck(g.sig);
      if (!g || choice === 'all') { closeBracketPanel(); return; }
      var panel = document.getElementById('cart-bracket-panel');
      if (panel) panel.classList.add('is-busy');
      var updates = {};
      g.sizes.forEach(function (s) { if (String(s.variantId) !== String(choice)) updates[s.variantId] = 0; });
      try {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
      } catch (e) {}
      closeBracketPanel();
      await refreshCart();
    }

    // ============ AUTO-ADD PRODUCT (GIFT) ============
    // Configurado desde Theme settings → "Auto-add product (gift)".
    var GIFT_ENABLED = CFG.giftEnabled;
    var GIFT_VARIANT_ID = CFG.giftVariantId;
    var GIFT_PRODUCT_ID = CFG.giftProductId;
    var GIFT_LABEL = CFG.giftLabel;
    // Regla: el producto-gift está presente en el carrito <=> hay al menos otro producto.
    // Se añade una sola vez (qty 1, property _gift) y se elimina si queda solo él.
    // Usamos YUXUS_FETCH_INTERCEPTED para que el interceptor de /cart/add no reabra el drawer.
    var giftBusy = false;
    async function ensureGiftInCart() {
      if (!GIFT_ENABLED || !GIFT_VARIANT_ID || giftBusy) return;
      giftBusy = true;
      try {
        const gcart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
        let giftLine = null, giftQty = 0, nonGiftQty = 0, manualGiftLines = [];
        gcart.items.forEach(function (it) {
          var p = it.properties || {};
          var isGift = p._gift === 'true' || p._gift === true;
          if (isGift) { giftLine = it; giftQty += it.quantity; }
          // Línea del producto-gift añadida a mano (sin _gift): NO permitida, se quitará.
          else if (GIFT_PRODUCT_ID && it.product_id === GIFT_PRODUCT_ID) { manualGiftLines.push(it); }
          else { nonGiftQty += it.quantity; }
        });
        window.YUXUS_FETCH_INTERCEPTED = true;
        try {
          // El producto-gift solo puede existir como gift automático: quitar manuales.
          for (var m = 0; m < manualGiftLines.length; m++) {
            await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: manualGiftLines[m].key, quantity: 0 }) });
          }
          if (nonGiftQty > 0 && !giftLine) {
            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _gift: 'true' } }] }) });
          } else if (nonGiftQty === 0 && giftLine) {
            await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: giftLine.key, quantity: 0 }) });
          } else if (giftLine && giftQty > 1) {
            await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: giftLine.key, quantity: 1 }) });
          }
        } finally { window.YUXUS_FETCH_INTERCEPTED = false; }
      } catch (e) {} finally { giftBusy = false; }
    }
    window.ensureGiftInCart = ensureGiftInCart;

    // Parpadeo de fotos al abrir el carrito: refreshCart() y el cross-sell rehacen el HTML en
    // cada apertura y cada <img> nuevo se volvía a pintar (en blanco un instante). Aquí se
    // reutilizan los <img> ya cargados de la misma foto (mismo fichero, da igual host o tamaño).
    function yxImgKey(src) {
      var m = String(src || '').split('?')[0].split('/').pop() || '';
      return m.replace(/_(\d+x\d*|x\d+)(_crop_\w+)?(?=\.\w+$)/, '').toLowerCase();
    }
    function yxCartImgSrc(url) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240' : url; }
    function yxSetHtmlKeepImages(container, html) {
      var old = {};
      container.querySelectorAll('img').forEach(function (i) {
        if (!i.complete || !i.naturalWidth) return;
        var k = yxImgKey(i.getAttribute('src')); (old[k] = old[k] || []).push(i);
      });
      container.innerHTML = html;
      container.querySelectorAll('img').forEach(function (n) {
        var list = old[yxImgKey(n.getAttribute('src'))];
        if (!list || !list.length) return;
        var o = list.shift();
        o.alt = n.alt;
        var oe = n.getAttribute('onerror'); if (oe) o.setAttribute('onerror', oe);
        n.parentNode.replaceChild(o, n);
      });
    }

    let refreshCartRequestId = 0;
    async function refreshCart() {
      const requestId = ++refreshCartRequestId;
      try {
        await ensureGiftInCart();
        const readStartedAt = Date.now();
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const productHandles = new Set();
        cart.items.forEach(item => { if (item.handle) productHandles.add(item.handle); });
        await Promise.all(Array.from(productHandles).map(handle => fetchProductData(handle)));
        // Una lectura anterior puede terminar después de un añadido o cambio.
        // Solo la actualización más reciente puede sustituir el contenido.
        if (requestId !== refreshCartRequestId) return;
        lastCart = cart;
        // El contador del header usa este mismo dato (antes hacía su propia lectura y a veces se quedaba atrás).
        if (window.YX_SET_CART_COUNT) window.YX_SET_CART_COUNT(cart, readStartedAt);
        const cartCountSpan = document.getElementById('cart-tab-count');
        if (cartCountSpan) cartCountSpan.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        const itemsContainer = document.getElementById('cart-items-container');
        const contentArea = drawer.querySelector('.cart-drawer-yuxus__content');
        const crosssellSection = document.getElementById('crosssell-section');
        const shippingWrapper = document.getElementById('shipping-wrapper');
        const footerWrapper = document.getElementById('footer-wrapper');
        
        if (itemsContainer && cart.item_count > 0) {
          if (contentArea) contentArea.classList.remove('cart-drawer-yuxus__content--empty');
          let itemsHTML = '';
          // El gift siempre primero en pantalla. Guardamos el `line` real del carrito
          // (posición original) porque updateQuantity() lo usa; solo reordenamos el render.
          const orderedItems = cart.items.map(function (it, i) { return { it: it, line: i + 1 }; });
          orderedItems.sort(function (a, b) {
            var ag = (a.it.properties && (a.it.properties._gift === 'true' || a.it.properties._gift === true)) ? 0 : 1;
            var bg = (b.it.properties && (b.it.properties._gift === 'true' || b.it.properties._gift === true)) ? 0 : 1;
            return ag - bg;
          });
          // Anti-bracketing: mismo producto en 2+ tallas (variantes distintas, sin
          // contar el regalo). El aviso va debajo de la última línea de ese producto.
          const bracketGroups = [];
          if (BRACKETING_ON) {
            const byProduct = {};
            // cart.items en su orden original = lo último añadido primero.
            cart.items.forEach(function (it) {
              const p = it.properties || {};
              if (p._gift === 'true' || p._gift === true) return;
              let g = byProduct[it.product_id];
              if (!g) {
                g = byProduct[it.product_id] = { productId: it.product_id, handle: it.handle, title: (it.product_title || '').toUpperCase(), image: it.image || '', sizes: [], seen: {} };
              }
              if (g.seen[it.variant_id]) return;
              g.seen[it.variant_id] = true;
              g.sizes.push({ variantId: it.variant_id, label: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '' });
            });
            Object.keys(byProduct).forEach(function (id) {
              const g = byProduct[id];
              if (g.sizes.length < 2) return;
              g.sig = id + ':' + g.sizes.map(function (s) { return s.variantId; }).sort().join(',');
              bracketGroups.push(g);
            });
          }
          for (let index = 0; index < orderedItems.length; index++) {
            const item = orderedItems[index].it; const line = orderedItems[index].line;
            const variantText = item.variant_title !== 'Default Title' ? item.variant_title : '';
            const sizeLabel = CFG.t_yuxus_cart_size;
            const presaleTag = CFG.t_yuxus_cart_presale;
            let priceHTML = '';
            const comparePrice = window.YUXUS_VARIANT_PRICES[item.variant_id];
            if (comparePrice && comparePrice > item.price) { priceHTML = '<span class="cart-drawer-yuxus__sale-price">' + formatMoney(item.final_line_price) + '</span><span class="cart-drawer-yuxus__compare-price">' + formatMoney(comparePrice * item.quantity) + '</span>'; }
            else { priceHTML = '<span class="cart-drawer-yuxus__regular-price">' + formatMoney(item.final_line_price) + '</span>'; }
            const presaleData = window.YUXUS_VARIANT_PRESALE[item.variant_id] || { isPresale: false, dates: '' };
            let fromCrosssell = false;
            if (item.properties) { for (const prop of Object.entries(item.properties)) { if (prop[0] === '_source' && prop[1] === 'cart_crosssell') { fromCrosssell = true; break; } } }
            let isGiftItem = false;
            if (item.properties) { for (const prop of Object.entries(item.properties)) { if (prop[0] === '_gift' && (prop[1] === 'true' || prop[1] === true)) { isGiftItem = true; break; } } }
            
            // ✅ NUEVO: Determinar si este item es FORHERPREVENTA
            // Como /cart.js no trae tags, nos basamos en el array inicial de Liquid
            // y en el mapa dinámico YUXUS_PRODUCT_FORHER
            var itemIsForher = FORHER_PRODUCT_IDS.includes(item.product_id) || !!window.YUXUS_PRODUCT_FORHER[item.product_id];
            
            // ✅ NUEVO: Determinar si ocultar el tag PREVENTA/PRESALE
            // Se oculta si FORHERPREVENTA o si presale cercana (<4 días)
            var hidePresaleTag = false;
            if (presaleData.isPresale) {
              hidePresaleTag = shouldShowPresaleAsNormalCart(item.product_id, presaleData.dates);
            }
            
            // ✅ Solo mostrar tag si es presale Y NO se debe ocultar
            var showPresaleTag = presaleData.isPresale && !hidePresaleTag;
            
            let variantRowHTML = '';
            // Cambio de talla en la propia línea (no en el regalo).
            const sizeInfo = isGiftItem ? null : getCartSizeOptions(item);
            const variantLabelHTML = sizeInfo
              ? '<button type="button" class="cart-drawer-yuxus__item-variant cart-drawer-yuxus__size-toggle" data-line="' + line + '" aria-expanded="false">' + sizeLabel + ': ' + variantText + '<svg width="8" height="5" viewBox="0 0 8 5" aria-hidden="true"><path d="M1 1l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.2"/></svg></button>'
              : '<p class="cart-drawer-yuxus__item-variant">' + sizeLabel + ': ' + variantText + '</p>';
            const sizePickerHTML = sizeInfo
              ? '<div class="cart-drawer-yuxus__size-picker" hidden>' + sizeInfo.siblings.map(function (v) {
                  const cur = String(v.id) === String(item.variant_id);
                  return '<button type="button" class="cart-drawer-yuxus__size-opt' + (cur ? ' is-current' : '') + '" data-line="' + line + '" data-variant-id="' + v.id + '"' + (!v.available && !cur ? ' disabled' : '') + '>' + bpEsc(v.options[sizeInfo.sizeIdx]) + '</button>';
                }).join('') + '</div>'
              : '';
            if (variantText) { variantRowHTML = '<div class="cart-drawer-yuxus__item-variant-row">' + variantLabelHTML + (showPresaleTag ? '<span class="cart-drawer-yuxus__presale-tag">' + presaleTag + '</span>' : '') + '</div>'; }
            else if (showPresaleTag) { variantRowHTML = '<div class="cart-drawer-yuxus__item-variant-row"><span class="cart-drawer-yuxus__presale-tag">' + presaleTag + '</span></div>'; }
            if (isGiftItem && GIFT_LABEL) { variantRowHTML = '<div class="cart-drawer-yuxus__item-variant-row">' + (variantText ? '<p class="cart-drawer-yuxus__item-variant">' + sizeLabel + ': ' + variantText + '</p>' : '') + '<span class="cart-drawer-yuxus__gift-tag">' + GIFT_LABEL + '</span></div>'; }
            itemsHTML += '<div class="cart-drawer-yuxus__item" data-line="' + line + '" data-gift="' + (isGiftItem ? 'true' : 'false') + '" data-variant-id="' + item.variant_id + '" data-product-id="' + item.product_id + '" data-product-handle="' + item.handle + '" data-is-presale="' + (presaleData.isPresale ? 'true' : 'false') + '" data-presale-dates="' + (presaleData.dates || '') + '" data-from-crosssell="' + fromCrosssell + '" data-is-forher="' + (itemIsForher ? 'true' : 'false') + '"><div class="cart-drawer-yuxus__item-image">' + (item.image ? '<img src="' + yxCartImgSrc(item.image) + '" alt="' + item.title + '">' : '') + '</div><div class="cart-drawer-yuxus__item-details"><div class="cart-drawer-yuxus__item-header"><h3 class="cart-drawer-yuxus__item-title"><a href="' + item.url + '">' + item.product_title.toUpperCase() + '</a></h3><button class="cart-drawer-yuxus__remove" data-line="' + line + '" aria-label="Remove item">×</button></div>' + variantRowHTML + (variantText && !isGiftItem ? sizePickerHTML : '') + '<div class="cart-drawer-yuxus__item-footer"><div class="cart-drawer-yuxus__quantity"><button class="cart-drawer-yuxus__quantity-btn" data-action="decrease" data-line="' + line + '">−</button><span class="cart-drawer-yuxus__quantity-value">' + item.quantity + '</span><button class="cart-drawer-yuxus__quantity-btn" data-action="increase" data-line="' + line + '">+</button></div><div class="cart-drawer-yuxus__item-price">' + priceHTML + '</div></div></div></div>';
          }
          yxSetHtmlKeepImages(itemsContainer, itemsHTML);
          if (crosssellSection) crosssellSection.style.display = 'block';
          if (shippingWrapper) shippingWrapper.style.display = 'block';
          if (footerWrapper) footerWrapper.style.display = 'block';
          if (loyaltyData) updateLoyaltyDisplayWithTotal(cart.total_price);
          try { maybeOpenBracketPanel(bracketGroups); } catch (e) { console.warn('[cart bracketing]', e); }
        } else if (itemsContainer && cart.item_count === 0) {
          if (contentArea) contentArea.classList.add('cart-drawer-yuxus__content--empty');
          itemsContainer.innerHTML = '<div class="cart-drawer-yuxus__empty"><p class="cart-drawer-yuxus__empty-title">' + (CFG.t_yuxus_cart_empty_title) + '</p><a href="' + CFG.root + '/collections/all" class="cart-drawer-yuxus__continue-btn">' + (CFG.t_yuxus_cart_continue_shopping) + '</a></div>';
          if (crosssellSection) crosssellSection.style.display = 'none';
          if (shippingWrapper) shippingWrapper.style.display = 'none';
          if (footerWrapper) footerWrapper.style.display = 'none';
          hideLoyaltyBar();
          if (window.yuxusClearCartTimer) window.yuxusClearCartTimer();
        }
        updateSubtotalWithDiscount(cart);
        setTimeout(() => { updateCartDeliveryTimer(); updateFreeShippingBar(); if (cart.item_count > 0) renderCrossSellProducts(); }, 100);
      } catch (error) {}
    }
    
    window.refreshCart = refreshCart;

    // ---- Cambio de talla desde el carrito ----
    // Solo cambia la opción de talla: el resto de opciones (si las hay) se quedan como están.
    var lastCart = null;
    var sizeSwapBusy = false;
    var SIZE_OPTION_RE = /^(size|talla|taille|taglia|gr(ö|o)(ß|ss)e|tamanho|maat)$/i;
    function getCartSizeOptions(item) {
      const product = window.YUXUS_CART_PRODUCTS[item.handle];
      if (!product || !product.variants || product.variants.length < 2) return null;
      const current = product.variants.find(function (v) { return String(v.id) === String(item.variant_id); });
      if (!current || !current.options) return null;
      const names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
      let sizeIdx = names.findIndex(function (n) { return SIZE_OPTION_RE.test(String(n).trim()); });
      if (sizeIdx < 0) sizeIdx = current.options.length - 1;
      const siblings = product.variants.filter(function (v) {
        return v.options && v.options.every(function (o, i) { return i === sizeIdx || o === current.options[i]; });
      });
      return siblings.length < 2 ? null : { sizeIdx: sizeIdx, siblings: siblings };
    }

    function isGiftLine(it) { const p = it.properties || {}; return p._gift === 'true' || p._gift === true; }

    // Primero se añade la talla nueva y luego se quita la vieja: si no hay stock no se pierde nada.
    // Va por originalFetch para que el interceptor de /cart/add no refresque a mitad (el aviso de
    // anti-bracketing vería las dos tallas un instante).
    async function changeCartItemSize(line, newVariantId, el) {
      if (sizeSwapBusy || !lastCart) return;
      const item = lastCart.items[line - 1];
      if (!item || String(item.variant_id) === String(newVariantId)) return;
      sizeSwapBusy = true;
      const itemEl = el && el.closest('.cart-drawer-yuxus__item');
      if (itemEl) itemEl.classList.add('is-updating');
      const post = function (url, body) { return originalFetch.call(window, url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); };
      try {
        if (window.YUXUS_VARIANT_PRESALE[item.variant_id] && !window.YUXUS_VARIANT_PRESALE[newVariantId]) window.YUXUS_VARIANT_PRESALE[newVariantId] = window.YUXUS_VARIANT_PRESALE[item.variant_id];
        const existing = lastCart.items.find(function (it) { return String(it.variant_id) === String(newVariantId) && !isGiftLine(it); });
        const res = existing
          ? await post('/cart/change.js', { id: existing.key, quantity: existing.quantity + item.quantity })
          : await post('/cart/add.js', { items: [{ id: Number(newVariantId), quantity: item.quantity, properties: item.properties || {} }] });
        if (!res.ok) throw new Error('size swap add failed');
        await post('/cart/change.js', { id: item.key, quantity: 0 });
      } catch (e) {
        console.warn('[cart size change]', e);
      } finally {
        sizeSwapBusy = false;
        await refreshCart();
      }
    }
    
    async function updateQuantity(line, quantity) {
      try {
        const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) });
        if (!response.ok) throw new Error('Error updating cart');
        await refreshCart();
      } catch (error) {}
    }
    
    const displayPriceCache = {};
    (window.YUXUS_FALLBACK_PRODUCTS || []).forEach(function(p) { if (p.id && p.price) displayPriceCache[p.id] = p.price; });

    async function getDisplayPrice(product) {
      if (displayPriceCache[product.id]) return displayPriceCache[product.id];
      if (product.handle) {
        try { const res = await fetch('/products/' + product.handle + '.js'); const data = await res.json(); const f = formatMoney(data.price); displayPriceCache[product.id] = f; return f; } catch (e) {}
      }
      return product.price || formatMoney(product.priceRaw || 0);
    }

    // Fetch cart-aware recommendations (complete_look + filtered fallback) from the
    // dedicated section via the Section Rendering API, then refresh the local pool.
    async function fetchCartRecommendations() {
      try {
        const res = await fetch('/?sections=cart-recommendations', { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return;
        const data = await res.json();
        const html = data['cart-recommendations'];
        if (typeof html !== 'string') return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const script = tmp.querySelector('#yuxus-cart-reco-data');
        if (!script) return;
        const parsed = JSON.parse((script.textContent || '[]').trim() || '[]');
        if (Array.isArray(parsed)) {
          window.YUXUS_FALLBACK_PRODUCTS = parsed;
          parsed.forEach(function(p) { if (p && p.id && p.price) displayPriceCache[p.id] = p.price; });
        }
      } catch (e) {}
    }

    async function renderCrossSellProducts() {
      const container = document.getElementById('crosssell-products-container');
      const crosssellSection = document.getElementById('crosssell-section');
      if (!container) return;
      try {
        await fetchCartRecommendations();
        const response = await fetch('/cart.js'); const cart = await response.json();
        if (cart.item_count === 0) { if (crosssellSection) crosssellSection.style.display = 'none'; container.innerHTML = ''; return; }
        const cartProductIds = cart.items.map(item => item.product_id);
        let products = getCrossSellProducts(cartProductIds);
        if (products.length === 0) {
          if (crosssellSection) crosssellSection.style.display = 'none';
          container.innerHTML = '';
          return;
        }
        if (crosssellSection) crosssellSection.style.display = 'block';
        const displayPrices = await Promise.all(products.map(p => getDisplayPrice(p)));
        let html = '';
        products.forEach((product, idx) => {
          const btnTitle = CFG.t_yuxus_cart_add;
          html += '<div class="crosssell-product" data-product-id="' + product.id + '"><div class="crosssell-product-image"><img src="' + product.image + '" alt="' + product.title + '" loading="lazy" onerror="this.closest(\'.crosssell-product\').style.display=\'none\'"><div class="crosssell-product-price">' + displayPrices[idx] + '</div><button class="crosssell-product-add-btn" data-product=\'' + JSON.stringify(product).replace(/'/g, '&apos;') + '\' title="' + btnTitle + '">+</button></div></div>';
        });
        yxSetHtmlKeepImages(container, html);
        container.querySelectorAll('.crosssell-product-add-btn').forEach(btn => {
          btn.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation();
            const pd = JSON.parse(this.dataset.product);
            const av = pd.variants.filter(v => v.available);
            if (av.length === 1) { const v = av[0]; addCrossSellItem(v.id, pd.url, v.compare_at_price, pd.handle, v.isPresale, v.presaleDates, pd.title, v.title, v.price, pd.id); }
            else { showSizePopup(pd); }
          });
        });
      } catch (error) { if (crosssellSection) crosssellSection.style.display = 'none'; }
    }
    
    drawer.addEventListener('click', function(e) {
      const target = e.target;
      if (target.classList.contains('cart-drawer-yuxus__quantity-btn')) {
        e.preventDefault();
        const line = parseInt(target.dataset.line); const action = target.dataset.action;
        const currentQty = parseInt(target.parentElement.querySelector('.cart-drawer-yuxus__quantity-value').textContent);
        updateQuantity(line, action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1));
      }
      if (target.classList.contains('cart-drawer-yuxus__remove')) { e.preventDefault(); updateQuantity(parseInt(target.dataset.line), 0); }
      const sizeToggle = target.closest('.cart-drawer-yuxus__size-toggle');
      if (sizeToggle) {
        e.preventDefault();
        const picker = sizeToggle.closest('.cart-drawer-yuxus__item-details').querySelector('.cart-drawer-yuxus__size-picker');
        const willOpen = picker && picker.hidden;
        drawer.querySelectorAll('.cart-drawer-yuxus__size-picker').forEach(function (p) { p.hidden = true; });
        drawer.querySelectorAll('.cart-drawer-yuxus__size-toggle').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (willOpen) { picker.hidden = false; sizeToggle.setAttribute('aria-expanded', 'true'); }
        return;
      }
      const sizeOpt = target.closest('.cart-drawer-yuxus__size-opt');
      if (sizeOpt && !sizeOpt.disabled) {
        e.preventDefault();
        if (sizeOpt.classList.contains('is-current')) { sizeOpt.parentElement.hidden = true; return; }
        changeCartItemSize(parseInt(sizeOpt.dataset.line), sizeOpt.dataset.variantId, sizeOpt);
        return;
      }
      const sgLink = target.closest('.cart-drawer-yuxus__bp-guide');
      if (sgLink) { e.preventDefault(); openCartSizeGuide(sgLink.dataset.sgHandle, sgLink); }
      if (target.closest('.cart-drawer-yuxus__sgv-back')) { e.preventDefault(); closeCartSizeGuide(); return; }
      const bpBtn = target.closest('[data-bp-keep]');
      if (bpBtn) { e.preventDefault(); bracketKeep(bpBtn.dataset.bpKeep); }
    });
    
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    
    document.addEventListener('click', function(e) {
      const popup = document.getElementById('yuxus-size-popup');
      // El selector vive en body, fuera del drawer. Su clic sigue siendo interno
      // aunque el propio control ya haya cerrado el selector antes del bubbling.
      if (e.target.closest('#yuxus-size-popup, #yuxus-size-popup-overlay')) return;
      if (popup && popup.classList.contains('active')) return;
      if (drawer.classList.contains('is-open')) {
        if (!drawer.contains(e.target) && !e.target.closest('.size-guide-modal') && !e.target.closest('#cart-sg-holder') && !e.target.closest('[data-action="open-drawer"]') && !e.target.closest('.cart-link') && !e.target.closest('.add-to-cart') && !e.target.closest('#cart-icon-bubble')) closeDrawer();
      }
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const popup = document.getElementById('yuxus-size-popup');
        if (popup && popup.classList.contains('active')) closeSizePopup();
        else if (drawer.classList.contains('is-open')) closeDrawer();
      }
    });
    
    const originalFetch = window.fetch;
    window.fetch = function() {
      const url = arguments[0];
      if (window.YUXUS_FETCH_INTERCEPTED) return originalFetch.apply(this, arguments);
      if (url && (url.includes('/cart/add') || url === '/cart/add.js')) {
        // Con el carrito ya abierto: se refresca igual, para que salga el aviso de talla.
        if (drawer.classList.contains('is-open')) return originalFetch.apply(this, arguments).then(function (res) { if (res.ok) setTimeout(refreshCart, 150); return res; });
        const preAddScroll = window.pageYOffset || document.documentElement.scrollTop;
        return originalFetch.apply(this, arguments).then(response => {
          if (response.ok) {
            if (window.yuxusResetCartTimer) window.yuxusResetCartTimer();
            const savedScroll = window.pageYOffset || document.documentElement.scrollTop || preAddScroll;
            scrollPosition = savedScroll;
            const scrollGuard = function() { window.scrollTo(0, savedScroll); };
            window.addEventListener('scroll', scrollGuard);
            document.documentElement.style.scrollBehavior = 'auto';
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            setTimeout(() => {
              window.removeEventListener('scroll', scrollGuard);
              document.documentElement.style.scrollBehavior = '';
              if (drawer.classList.contains('is-open')) return;
              document.body.style.overflow = '';
              document.documentElement.style.overflow = '';
              window.scrollTo(0, savedScroll);
              if (window.YUXUS_CART && window.YUXUS_CART.open) window.YUXUS_CART.open();
            }, 150);
          }
          return response;
        });
      }
      return originalFetch.apply(this, arguments);
    };
    
    updateCartDeliveryTimer();
    updateFreeShippingBar();

    fetch('/cart.js').then(r => r.json()).then(cart => { if (cart.item_count > 0) renderCrossSellProducts(); }).catch(() => {});

    // Reconcilia el gift en cada carga (sin abrir el drawer): añade el gift a carritos
    // pre-existentes con productos y limpia el gift huérfano si se vació el carrito en
    // otra superficie (p.ej. la página /cart de Dawn, que no pasa por refreshCart()).
    ensureGiftInCart();

    // ======================================================
    // WISHLIST IN CART (Cart / Wishlist tabs)
    // Reads the device-stored localStorage 'wishlist' (shape varies across the
    // theme: {id,title,image,url} or {handle,url,title,image}) — we tolerate both.
    // ======================================================
    const wishlistInCart = CFG.wishlistInCart;
    const cdwProductCache = {};

    function cdwRead() {
      try { const a = JSON.parse(localStorage.getItem('wishlist') || '[]'); return Array.isArray(a) ? a : []; }
      catch (e) { return []; }
    }
    function cdwHandle(item) {
      if (!item) return null;
      if (item.handle) return item.handle;
      if (item.url) { const part = String(item.url).split('/products/')[1]; if (part) return part.split('?')[0].split('#')[0].split('/')[0]; }
      return null;
    }
    function cdwUpdateCount() {
      const badge = document.getElementById('wishlist-tab-count');
      if (!badge) return;
      const n = cdwRead().length;
      badge.textContent = n > 0 ? '(' + n + ')' : '';
    }
    function cdwRemove(handle) {
      const list = cdwRead().filter(it => cdwHandle(it) !== handle);
      localStorage.setItem('wishlist', JSON.stringify(list));
      cdwUpdateCount();
      renderWishlistInCart();
    }

    async function cdwFetchProduct(handle) {
      if (!handle) return null;
      if (cdwProductCache[handle]) return cdwProductCache[handle];
      try {
        const res = await fetch('/products/' + handle + '.js');
        if (!res.ok) return null;
        const p = await res.json();
        cdwProductCache[handle] = p;
        return p;
      } catch (e) { return null; }
    }

    async function renderWishlistInCart() {
      const container = document.getElementById('cart-wishlist-items');
      if (!container) return;
      const items = cdwRead();
      if (items.length === 0) {
        container.innerHTML = '<div class="cdw-empty"><p>' + (CFG.t_yuxus_cart_wishlist_empty) + '</p><a href="' + CFG.root + '/collections/all">' + (CFG.t_yuxus_cart_wishlist_discover) + '</a></div>';
        return;
      }
      container.innerHTML = '<div class="cdw-loading">' + (CFG.t_yuxus_cart_wishlist_loading) + '</div>';
      const resolved = await Promise.all(items.map(async (it) => {
        const handle = cdwHandle(it);
        if (!handle) return null;
        const product = await cdwFetchProduct(handle);
        return { item: it, handle: handle, product: product };
      }));
      let html = '';
      resolved.forEach(r => {
        if (!r) return;
        const it = r.item, p = r.product, handle = r.handle;
        const title = ((p && p.title) || it.title || '').toString();
        const url = it.url || (p ? '/products/' + handle : '#');
        let image = it.image || (p && p.featured_image) || (p && p.images && p.images[0]) || '';
        let priceHtml = '';
        let soldOut = false;
        if (p) {
          if (p.compare_at_price && p.compare_at_price > p.price) {
            priceHtml = '<span class="cdw-sale">' + formatMoney(p.price) + '</span><span class="cdw-compare">' + formatMoney(p.compare_at_price) + '</span>';
          } else {
            priceHtml = formatMoney(p.price);
          }
          soldOut = !p.available;
        }
        const addLabel = soldOut ? (CFG.t_yuxus_cart_sold_out) : (CFG.t_yuxus_cart_add_upper);
        const safeTitle = title.replace(/"/g, '&quot;');
        html += '<div class="cdw-item" data-handle="' + handle + '">'
          + '<div class="cdw-item__image">' + (image ? '<img src="' + image + '" alt="' + safeTitle + '" loading="lazy">' : '') + '</div>'
          + '<div class="cdw-item__details">'
          + '<h3 class="cdw-item__title"><a href="' + url + '">' + title.toUpperCase() + '</a></h3>'
          + '<p class="cdw-item__price">' + priceHtml + '</p>'
          + '<div class="cdw-item__spacer"></div>'
          + '<div class="cdw-item__actions">'
          + '<button class="cdw-item__add" data-handle="' + handle + '"' + (soldOut ? ' disabled style="opacity:.5;cursor:not-allowed;"' : '') + '>' + addLabel + '</button>'
          + '<button class="cdw-item__remove" data-handle="' + handle + '" aria-label="Remove">×</button>'
          + '</div></div></div>';
      });
      container.innerHTML = html;
    }

    function cdwBuildPopupProduct(p, handle) {
      return {
        id: p.id,
        title: p.title,
        url: '/products/' + handle,
        handle: handle,
        variants: (p.variants || []).map(v => ({
          id: v.id,
          title: (v.title === 'Default Title') ? 'ONE SIZE' : (v.title || '').toUpperCase(),
          price: v.price,
          available: v.available,
          compare_at_price: v.compare_at_price || '',
          isPresale: false,
          presaleDates: ''
        }))
      };
    }

    async function cdwAddToCart(handle) {
      const p = await cdwFetchProduct(handle);
      if (!p) return;
      const popupProduct = cdwBuildPopupProduct(p, handle);
      const avail = popupProduct.variants.filter(v => v.available);
      if (avail.length === 0) return;
      if (avail.length === 1) {
        const v = avail[0];
        addCrossSellItem(v.id, popupProduct.url, v.compare_at_price, handle, false, '', popupProduct.title, v.title, v.price, popupProduct.id);
        setCartView('cart');
      } else {
        showSizePopup(popupProduct);
      }
    }

    function setCartView(view) {
      if (!wishlistInCart) return;
      const v = view === 'wishlist' ? 'wishlist' : 'cart';
      if (v === 'wishlist') { drawer.classList.add('is-wishlist-view'); cdwUpdateCount(); renderWishlistInCart(); }
      else { drawer.classList.remove('is-wishlist-view'); }
      drawer.querySelectorAll('.cart-drawer-yuxus__tab').forEach(tab => {
        const active = tab.dataset.cartView === v;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    window.YUXUS_CART.setView = setCartView;

    if (wishlistInCart) {
      drawer.addEventListener('click', function(e) {
        const tab = e.target.closest('.cart-drawer-yuxus__tab');
        if (tab) { e.preventDefault(); setCartView(tab.dataset.cartView); return; }
        const addBtn = e.target.closest('.cdw-item__add');
        if (addBtn && !addBtn.disabled) { e.preventDefault(); cdwAddToCart(addBtn.dataset.handle); return; }
        const rmBtn = e.target.closest('.cdw-item__remove');
        if (rmBtn) { e.preventDefault(); cdwRemove(rmBtn.dataset.handle); return; }
      });
      // Reset to cart view each time the drawer opens, and refresh the badge.
      const _origOpen = window.YUXUS_CART.open;
      window.YUXUS_CART.open = function() { setCartView('cart'); cdwUpdateCount(); return _origOpen.apply(this, arguments); };
      window.SLIDECART_OPEN = window.YUXUS_CART.open;
      // Keep the badge in sync when the wishlist changes from other tabs / hearts.
      window.addEventListener('storage', function(e) { if (e.key === 'wishlist') { cdwUpdateCount(); if (drawer.classList.contains('is-wishlist-view')) renderWishlistInCart(); } });
      document.addEventListener('wishlist:updated', function() { cdwUpdateCount(); if (drawer.classList.contains('is-wishlist-view')) renderWishlistInCart(); });
      cdwUpdateCount();
    }

    window.YUXUS_DEBUG = { openDrawer: openDrawer, closeDrawer: closeDrawer, refreshCart: refreshCart };
  });
})();
